var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-container',[_c('el-aside',{staticClass:"backcolor",staticStyle:{"height":"100vh","width":"auto"}},[_c('Menu')],1),_c('el-container',[_c('el-header',{staticStyle:{"padding":"0","height":"auto"}},[_c('Header')],1),_c('el-main',{staticStyle:{"background-color":"#ccc","height":"100%","padding":"5px"}},[_c('router-view')],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }